import React from 'react';
import { Form, Input, Select } from 'antd';
import AppModal from '@pages/inside/tenant/AppModal';
import { Button } from '@components/ui/Button';
import { CreateRoleModalBody, CreateRoleModalFooter } from '@pages/inside/tenant/style';

/**
 * Create tenant user (same fields as Users page), for use from project flows.
 */
export default function CreateUserFormModal({
    open,
    onCancel,
    form,
    roleOptions,
    onSubmit,
    loading,
    permissionDenied,
}) {
    return (
        <AppModal
            size="md"
            title="Create User"
            open={open}
            onCancel={onCancel}
            footer={null}
            styles={{ body: { paddingTop: 8 } }}
        >
            <CreateRoleModalBody>
                <Form form={form} layout="vertical">
                    <Form.Item name="name" label="Name" rules={[{ required: true, message: 'Enter name' }]}>
                        <Input placeholder="e.g. Jane Doe" size="large" />
                    </Form.Item>
                    <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                            { required: true, message: 'Enter email' },
                            { type: 'email', message: 'Enter a valid email' },
                        ]}
                    >
                        <Input placeholder="e.g. newuser@company.com" size="large" />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        label="Password"
                        rules={[
                            { required: true, message: 'Enter password' },
                            { min: 8, message: 'Password must be at least 8 characters' },
                        ]}
                    >
                        <Input.Password placeholder="e.g. SecurePass123!" size="large" />
                    </Form.Item>
                    <Form.Item name="roleId" label="Role" rules={[{ required: true, message: 'Select a role' }]}>
                        <Select placeholder="Select role" size="large" options={roleOptions} />
                    </Form.Item>
                </Form>
            </CreateRoleModalBody>
            <CreateRoleModalFooter>
                <Button type="button" $primary={false} onClick={onCancel} $padding="10px 16px" $size="14px">
                    Cancel
                </Button>
                <Button
                    type="button"
                    $primary
                    $blackOnLight
                    $padding="10px 16px"
                    $size="14px"
                    loading={loading}
                    onClick={onSubmit}
                    permissionDenied={permissionDenied}
                >
                    Create User
                </Button>
            </CreateRoleModalFooter>
        </AppModal>
    );
}
